import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { KTIcon } from '../../../../../_metronic/helpers'
import { resendCallbackAPI } from '../../../payment-tickets/core/_requests'

const AppSwal = withReactContent(Swal)

interface ResendCallbackButtonProps {
  token: string
  className?: string
  title?: string
  /**
   * Подпись рядом с иконкой. Нужна, когда кнопка живёт не в ряду иконок, а пунктом меню
   * (CPAYMENT-1615): без текста пункт меню нечитаем. Без неё поведение прежнее — только иконка.
   */
  label?: string
}

/**
 * Ручная переотправка последнего исходящего merchant callback (КБ) для
 * matching-тикета. UX повторяет обычные пополнения/выплаты
 * (иконка arrows-circle + подтверждение через SweetAlert).
 *
 * Бэкенд сам определяет payment/payout по токену
 * (POST /api/internal/callback/resend).
 *
 * stopPropagation нужен, чтобы клик по кнопке в строке finished-списка не
 * сворачивал/раскрывал блок связанной выплаты.
 */
export const ResendCallbackButton = ({
  token,
  className = 'btn btn-icon btn-bg-light btn-active-color-primary btn-sm fs-6',
  title = 'Повторно отправить мерчанту колбэк о текущем статусе тикета',
  label,
}: ResendCallbackButtonProps) => {
  const resendCallback = async () => {
    AppSwal.fire({
      title: 'Отправить КБ мерчанту?',
      text: 'Мерчанту будет повторно отправлен колбэк о текущем статусе тикета с актуальной подписью.',
      icon: 'question',
      showCancelButton: true,
      cancelButtonText: 'Отмена',
      confirmButtonText: 'Отправить',
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const response = await resendCallbackAPI(token)
          if (!response.data?.success) {
            throw new Error('сервис вернул ошибку')
          }
        } catch (err) {
          AppSwal.showValidationMessage(`Не удалось отправить КБ: ${err}`)
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        AppSwal.fire({
          title: 'КБ отправлен',
          icon: 'success',
          timer: 1500,
        })
      }
    })
  }

  return (
    <button
      className={className}
      onClick={(e) => {
        e.stopPropagation()
        resendCallback()
      }}
      title={title}
    >
      <KTIcon className={label ? 'fs-3 me-2' : 'fs-1'} iconName='arrows-circle' />
      {label}
    </button>
  )
}

export default ResendCallbackButton
